// extracted by mini-css-extract-plugin
export var box = "_8t-1";
export var checkboxRow = "_8t-8";
export var checked = "_8t-2";
export var descriptionSpacer = "_8t-a";
export var disabled = "_8t-3";
export var icon = "_8t-6";
export var input = "_8t-0";
export var labelSpacer = "_8t-9";
export var medium = "_8t-5";
export var small = "_8t-4";
export var text = "_8t-7";